import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LandingState {
    isLoginModalOpen: boolean
}


const initialState: LandingState = {
    isLoginModalOpen: false
}

const landingSlice = createSlice({
    name: 'landing',
    initialState,
    reducers: {
        landingToggleLoginModal: (state, action: PayloadAction<{}>) => {
            state.isLoginModalOpen = !state.isLoginModalOpen;
        },
    }
})

export const { landingToggleLoginModal } = landingSlice.actions;

export default landingSlice.reducer;